import { BaseEpisodeCardElementMixin } from "%/dynamic-component-editor/standard-components/base-episode-card/base-episode-card-element-mixin";

// Mirrors ShowPageElementMixin — routes Episode* elements through the
// episode-store + pageEntities wiring so production renders real data
// against the URL-derived episode_id.
export const EpisodePageElementMixin = {
  extends: BaseEpisodeCardElementMixin,
};
